import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PartnerUser {
  id: string;
  email: string;
  name: string;
  role: string;
  partnerCompanyId: string;
  partnerCompanyName: string | null;
}

interface PartnerAuthState {
  partnerUser: PartnerUser | null;
  token: string | null;
  expiresAt: Date | null;
  isAuthenticated: boolean;

  setAuth: (partnerUser: PartnerUser, token: string, expiresAt: Date | string) => void;
  clearAuth: () => void;
  updateToken: (token: string, expiresAt: Date | string) => void;
}

export const usePartnerAuthStore = create<PartnerAuthState>()(
  persist(
    (set) => ({
      partnerUser: null,
      token: null,
      expiresAt: null,
      isAuthenticated: false,

      setAuth: (partnerUser, token, expiresAt) => {
        localStorage.setItem('partnerToken', token);

        const expiryString = expiresAt instanceof Date
          ? expiresAt.toISOString()
          : expiresAt;
        localStorage.setItem('partnerTokenExpiry', expiryString);

        const expiryDate = expiresAt instanceof Date
          ? expiresAt
          : new Date(expiresAt);

        set({
          partnerUser,
          token,
          expiresAt: expiryDate,
          isAuthenticated: true,
        });
      },

      clearAuth: () => {
        localStorage.removeItem('partnerToken');
        localStorage.removeItem('partnerTokenExpiry');

        set({
          partnerUser: null,
          token: null,
          expiresAt: null,
          isAuthenticated: false,
        });
      },

      updateToken: (token, expiresAt) => {
        localStorage.setItem('partnerToken', token);

        const expiryString = expiresAt instanceof Date
          ? expiresAt.toISOString()
          : expiresAt;
        localStorage.setItem('partnerTokenExpiry', expiryString);

        const expiryDate = expiresAt instanceof Date
          ? expiresAt
          : new Date(expiresAt);

        set({
          token,
          expiresAt: expiryDate,
        });
      },
    }),
    {
      name: 'partner-auth-storage',
      partialize: (state) => ({
        partnerUser: state.partnerUser,
        isAuthenticated: state.isAuthenticated,
        token: state.token,
        expiresAt: state.expiresAt,
      }),
    }
  )
);
